export const treeSpawnStraight = [
    [30, 0, -50],
    [50, 0, -50],
    [30, 0, -40],
    [50, 0, -40],
    [30, 0, -30],
    [50, 0, -30],
    [30, 0, -20],
    [50, 0, -20],
    [30, 0, -10],
    [50, 0, -10],
    [30, 0, 0],
    [50, 0, 0],
    [30, 0, 10],
    [50, 0, 10],
    [30, 0, 20],
    [50, 0, 20],
    [30, 0, 30],
    [50, 0, 30],
    [30, 0, 40],
    [50, 0, 40],
    [30, 0, 50],
    [50, 0, 50],
    [30, 0, 60],
    [50, 0, 60],
    [-50, 0, -50],
    [-30, 0, -50],
    [-50, 0, -40],
    [-30, 0, -40],
    [-50, 0, -30],
    [-30, 0, -30],
    [-50, 0, -20],
    [-30, 0, -20],
    [-50, 0, -10],
    [-30, 0, -10],
    [-50, 0, 0],
    [-30, 0, 0],
    [-50, 0, 10],
    [-30, 0, 10],
    [-50, 0, 20],
    [-30, 0, 20],
    [-50, 0, 30],
    [-30, 0, 30],
    [-50, 0, 40],
    [-30, 0, 40],
    [-50, 0, 50],
    [-30, 0, 50],
    [-50, 0, 60],
    [-30, 0, 60]
]

export const peopleSpawnStart = [


    [12.8096, 0, -59.5276],
    [12.8096, 0, -56.5276],
    [13.2384, 0, -54.5276],
    [13.2384, 0, -52.0],
    [12.8096, 0, -50.0251],
    [13.2384, 0, -48.0],
    [13.2384, 0, -46.0251],
    [13.2384, 0, -44.5251],
    [13.2384, 0, -42.5251],
    [12.8096, 0, -40.5226],
    [13.2384, 0, -38.0],
    [13.2384, 0, -36.0],
    [13.2384, 0, -34.5226],
    [13.2384, 0, -32.5226],
    [12.8096, 0, -30.0201],
    [12.8096, 0, -28.0201],
    [13.2384, 0, -26.0200],
    [13.2384, 0, -24.0200],
    [13.2384, 0, -22.0200],
    [12.8096, 0, -20.5175],
    [13.2384, 0, -18.0200],
    [13.2384, 0, -16.5175],
    [13.2384, 0, -14.5175],
    [12.8096, 0, -12.0150],
    [12.8096, 0, -10.0150],
    [12.8096, 0, -8.0150],
    [13.2384, 0, -6.0150],
    [12.8096, 0, -4.5125],
    [12.8096, 0, -2.5125],
    [13.2384, 0, 2.4875],
    [13.2384, 0, 4.9900],
    [12.8096, 0, 6.9900],
    [13.2384, 0, 8.9900],
    [13.2384, 0, 10.9900],
    [13.2384, 0, 12.4925],
    [13.2384, 0, 14.4925],
    [12.8096, 0, 16.4925],
    [13.2384, 0, 18.4925],
    [13.2384, 0, 20.4925],
    [13.2384, 0, 22.9950],
    [12.8096, 0, 24.9950],
    [12.8096, 0, 26.9950],
    [13.2384, 0, 28.9950],
    [13.2384, 0, 30.4975],
    [13.2384, 0, 32.4975],
    [12.8096, 0, 34.4975],
    [13.2384, 0, 36.4975],
    [13.2384, 0, 38.4975],
    [13.2384, 0, 40.4975],
    [13.2384, 0, 42.4975],
    [12.8096, 0, 44],
    [13.2384, 0, 46.4975],
    [13.2384, 0, 48.4975],
    [13.2384, 0, 50],
    [13.2384, 0, 52.5],
    [13.2384, 0, 54],
    [13.2384, 0, 56.5],
    [13.2384, 0, 58],
    [13.2384, 0, 60],


    [-12.8096, 0, -60.5276],
    [-12.8096, 0, -58.5276],
    [-13.2384, 0, -54.5276],
    [-12.8096, 0, -52.0251],
    [-12.8096, 0, -50.0251],
    [-13.2384, 0, -48.0251],
    [-13.2384, 0, -46.0251],
    [-13.2384, 0, -44.0251],
    [-12.8096, 0, -42.5226],
    [-12.8096, 0, -40.5226],
    [-12.8096, 0, -38.5226],
    [-12.8096, 0, -36.5226],
    [-13.2384, 0, -34.5226],
    [-12.8096, 0, -32.0201],
    [-12.8096, 0, -30.0201],
    [-13.2384, 0, -28.0200],
    [-13.2384, 0, -26.0200],
    [-13.2384, 0, -24.0200],
    [-13.2384, 0, -22.5200],
    [-12.8096, 0, -20.5175],
    [-13.2384, 0, -18.5175],
    [-13.2384, 0, -16.5175],
    [-12.8096, 0, -14.0150],
    [-12.8096, 0, -12.0150],
    [-13.2384, 0, -10.0150],
    [-13.2384, 0, -8.0150],
    [-13.2384, 0, -6.0150],
    [-13.2384, 0, -4.0150],
    [-12.8096, 0, -2.5125],
    [-13.2384, 0, 0.0],
    [-13.2384, 0, 2.4875],
    [-12.8096, 0, 4.9900],
    [-12.8096, 0, 6.9900],
    [-13.2384, 0, 8.9900],
    [-13.2384, 0, 10.9900],
    [-12.8096, 0, 12.4925],
    [-12.8096, 0, 14.4925],
    [-12.8096, 0, 16.4925],
    [-13.2384, 0, 18.4925],
    [-13.2384, 0, 20.4925],
    [-12.8096, 0, 22.9950],
    [-12.8096, 0, 24.9950],
    [-13.2384, 0, 26.5],
    [-13.2384, 0, 28.5],
    [-13.2384, 0, 30.9950],
    [-12.8096, 0, 32.4975],
    [-12.8096, 0, 34.4975],
    [-13.2384, 0, 36.0],
    [-13.2384, 0, 38.0],
    [-13.2384, 0, 40.4975],
    [-13.2384, 0, 42.4975],
    [-12.8096, 0, 44],
    [-12.8096, 0, 46],
    [-12.8096, 0, 48],
    [-13.2384, 0, 50],
    [-13.2384, 0, 52.5],
    [-13.2384, 0, 54],
    [-13.2384, 0, 56.5],
    [-13.2384, 0, 58.5],
    [-13.2384, 0, 60]

]


export const airportLightsSpawnStraight = [
    [-6.5312, 0.4, 59.9123],
    [-2.4648, 0.4, 59.9123],
    [1.6016, 0.4, 59.9123],
    [5.6680, 0.4, 59.9123],
    [-6.5312, 0.4, 49.0032],
    [-2.4648, 0.4, 49.0032],
    [1.6016, 0.4, 49.0032],
    [5.6680, 0.4, 49.0032],
    [-6.5312, 0.4, 38.0941],
    [-2.4648, 0.4, 38.0941],
    [1.6016, 0.4, 38.0941],
    [5.6680, 0.4, 38.0941],
    [-6.5311, 0.4, 27.1850],
    [-2.4647, 0.4, 27.1850],
    [1.6017, 0.4, 27.1850],
    [5.6681, 0.4, 27.1850],
    [-6.5311, 0.4, 16.2759],
    [-2.4647, 0.4, 16.2759],
    [1.6017, 0.4, 16.2759],
    [5.6681, 0.4, 16.2759],
    [-6.5311, 0.4, 5.3668],
    [-2.4647, 0.4, 5.3668],
    [1.6017, 0.4, 5.3668],
    [5.6681, 0.4, 5.3668],
    [-6.5311, 0.4, -5.5423],
    [-2.4647, 0.4, -5.5423],
    [1.6017, 0.4, -5.5423],
    [5.6681, 0.4, -5.5423],
    [-6.5311, 0.4, -16.4513],
    [-2.4647, 0.4, -16.4513],
    [1.6017, 0.4, -16.4513],
    [5.6681, 0.4, -16.4513],
    [-6.5312, 0.4, -27.3604],
    [-2.4648, 0.4, -27.3604],
    [1.6016, 0.4, -27.3604],
    [5.6680, 0.4, -27.3604],
    [-6.5312, 0.4, -38.2695],
    [-2.4648, 0.4, -38.2695],
    [1.6016, 0.4, -38.2695],
    [5.6680, 0.4, -38.2695],
    [-6.5310, 0.4, -49.1786],
    [-2.4646, 0.4, -49.1786],
    [1.6018, 0.4, -49.1786],
    [5.6682, 0.4, -49.1786]
]

export const airportLightsSpawnCurveLeft = [
    [-51.8048, 0.4, 6.14203],
    [-51.2082, 0.4, 2.10858],
    [-50.6116, 0.4, -1.92487],
    [-50.0149, 0.4, -5.95831],
    [-44.2141, 0.4, 7.83948],
    [-43.0391, 0.4, 3.93542],
    [-41.8641, 0.4, 0.0313721],
    [-40.6891, 0.4, -3.87268],
    [-37.0688, 0.4, 10.5655],
    [-35.3482, 0.4, 6.86969],
    [-33.6276, 0.4, 3.17389],
    [-31.907, 0.4, -0.521912],
    [-30.446, 0.4, 14.2402],
    [-28.2234, 0.4, 10.8231],
    [-26.0007, 0.4, 7.40594],
    [-23.7781, 0.4, 3.98883],
    [-24.4303, 0.4, 18.7808],
    [-21.7549, 0.4, 15.7054],
    [-19.0795, 0.4, 12.6301],
    [-16.4041, 0.4, 9.55475],
    [-19.1095, 0.4, 24.1014],
    [-16.0342, 0.4, 21.426],
    [-12.9589, 0.4, 18.7505],
    [-9.88365, 0.4, 16.0751],
    [-14.5692, 0.4, 30.1169],
    [-11.152, 0.4, 27.8945],
    [-7.73479, 0.4, 25.6719],
    [-4.31757, 0.4, 23.4495],
    [-10.895, 0.4, 36.7391],
    [-7.19891, 0.4, 35.019],
    [-3.50284, 0.4, 33.2991],
    [0.193222, 0.4, 31.579],
    [-8.16853, 0.4, 43.8845],
    [-4.26434, 0.4, 42.71],
    [-0.360138, 0.4, 41.5354],
    [3.54405, 0.4, 40.3609],
    [-6.47099, 0.4, 51.475],
    [-2.43744, 0.4, 50.8789],
    [1.5961, 0.4, 50.2828],
    [5.62965, 0.4, 49.6868],
    [-5.86905, 0.4, 59.6645],
    [-1.80266, 0.4, 59.5151],
    [2.26375, 0.4, 59.3658],
    [6.33015, 0.4, 59.2166]
]

export const airportLightsSpawnCurveRight = [
    [51.8048, 0.4, 6.14191],
    [51.2082, 0.4, 2.10846],
    [50.6116, 0.4, -1.92499],
    [50.0149, 0.4, -5.95844],
    [44.2141, 0.4, 7.83936],
    [43.0391, 0.4, 3.9353],
    [41.8641, 0.4, 0.03125],
    [40.6891, 0.4, -3.8728],
    [37.0688, 0.4, 10.5654],
    [35.3482, 0.4, 6.86957],
    [33.6276, 0.4, 3.17377],
    [31.907, 0.4, -0.522034],
    [30.446, 0.4, 14.2401],
    [28.2234, 0.4, 10.8229],
    [26.0007, 0.4, 7.40582],
    [23.7781, 0.4, 3.98871],
    [24.4303, 0.4, 18.7807],
    [21.7549, 0.4, 15.7053],
    [19.0795, 0.4, 12.63],
    [16.4041, 0.4, 9.55463],
    [19.1095, 0.4, 24.1013],
    [16.0342, 0.4, 21.4258],
    [12.9589, 0.4, 18.7504],
    [9.88365, 0.4, 16.075],
    [14.5692, 0.4, 30.1168],
    [11.152, 0.4, 27.8943],
    [7.73479, 0.4, 25.6718],
    [4.31757, 0.4, 23.4493],
    [10.895, 0.4, 36.739],
    [7.19891, 0.4, 35.0189],
    [3.50284, 0.4, 33.299],
    [-0.193222, 0.4, 31.579],
    [8.16853, 0.4, 43.8844],
    [4.26434, 0.4, 42.7099],
    [0.360138, 0.4, 41.5354],
    [-3.54405, 0.4, 40.3609],
    [6.47099, 0.4, 51.4749],
    [2.43744, 0.4, 50.8789],
    [-1.5961, 0.4, 50.2828],
    [-5.62965, 0.4, 49.6868],
    [5.86905, 0.4, 59.6644],
    [1.80266, 0.4, 59.5151],
    [-2.26375, 0.4, 59.3658],
    [-6.33015, 0.4, 59.2166]
]

export const peopleSpawnCurveLeft = [
    [-45.2967, 1.22361, -14.2971],
    [15.6214, 0, 46.0132],
    [13.0864, 0, 36.8859],
    [9.52673, 0, 28.1073],
    [4.98888, 0, 19.7921],
    [-0.467934, 0, 12.0488],
    [-6.77242, 0, 4.97864],
    [-13.8423, 0, -1.32623],
    [-21.5853, 0, -6.78344],
    [-29.9002, 0, -11.3217],
    [-38.6786, 0, -14.8819],
    [-33.8464, 0, -13.5306],
    [-25.2537, 0, -9.42806],
    [-17.1851, 0, -4.37207],
    [-9.74594, 0, 1.57136],
    [-3.03335, 0, 8.32461],
    [2.86505, 0, 15.7995],
    [7.87224, 0, 23.8985],
    [11.9228, 0, 32.5158],
    [14.964, 0, 41.5389],
    [16.9559, 0, 50.85]
]

export const peopleSpawnCurveRight = [
    [45.2967, 1.22361, -14.2971],
    [-15.6214, 0, 46.0132],
    [-13.0864, 0, 36.8859],
    [-9.52673, 0, 28.1073],
    [-4.98888, 0, 19.7921],
    [0.467934, 0, 12.0488],
    [6.77242, 0, 4.97864],
    [13.8423, 0, -1.32623],
    [21.5853, 0, -6.78344],
    [29.9002, 0, -11.3217],
    [38.6786, 0, -14.8819],
    [33.8464, 0, -13.5306],
    [25.2537, 0, -9.42806],
    [17.1851, 0, -4.37207],
    [9.74594, 0, 1.57136],
    [3.03335, 0, 8.32461],
    [-2.86505, 0, 15.7995],
    [-7.87224, 0, 23.8985],
    [-11.9228, 0, 32.5158],
    [-14.964, 0, 41.5389],
    [-16.9559, 0, 50.85]
]
export const treeSpawnLeft = [
    [53.3518, 0, 23.1698],
    [36.4228, 0, -10.0553],
    [10.0553, 0, -36.4228],
    [-23.1698, 0, -53.3518],
    [-60, 0, -59.1852],
    [25.0139, 0, 32.3773],
    [12.3171, 0, 7.45854],
    [-7.45854, 0, -12.3171],
    [-32.3773, 0, -25.0139],
    [-60, 0, -29.3889],
    [27.2014, 0, 46.1887],
    [56.2685, 0, 41.5849],
    [18.6655, 0, 19.9179],
    [44.8873, 0, 6.55724],
    [2.42929, 0, -2.42929],
    [23.239, 0, -23.239],
    [-19.9179, 0, -18.6655],
    [-6.55724, 0, -44.8873],
    [-46.1887, 0, -27.2014],
    [-41.5849, 0, -56.2685]
]
export const treeSpawnRight = [
    [-53.3518, 0, 23.1698],
    [-36.4228, 0, -10.0553],
    [-10.0553, 0, -36.4228],
    [23.1698, 0, -53.3518],
    [60, 0, -59.1852],
    [-25.0139, 0, 32.3773],
    [-12.3171, 0, 7.45854],
    [7.45854, 0, -12.3171],
    [32.3773, 0, -25.0139],
    [60, 0, -29.3889],
    [-27.2014, 0, 46.1887],
    [-56.2685, 0, 41.5849],
    [-18.6655, 0, 19.9179],
    [-44.8873, 0, 6.55724],
    [-2.42929, 0, -2.42929],
    [-23.239, 0, -23.239],
    [19.9179, 0, -18.6655],
    [6.55724, 0, -44.8873],
    [46.1887, 0, -27.2014],
    [41.5849, 0, -56.2685]
]



// WEBPACK FOOTER //
// ./src/components/game/track-tiled/spawnSprites.js